<template>
    <v-form
        ref="form"
        lazy-validation
    >
        <v-row>
            <v-col cols="12" sm="6" md="6">
                <!-- <v-menu
                    offset-y
                    min-width="290px"
                    max-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            :value="newDate"
                            label="Date"
                            v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="newDate" scrollable></v-date-picker>
                </v-menu> -->
                <v-menu
                    ref="menu"
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="newDate"
                            label="Date"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules='requiredField'
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="newDate"
                        no-title
                        scrollable
                    >
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            color="primary"
                            @click="dateMenu = false"
                        >
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(date)"
                        >
                            OK
                        </v-btn>
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="6">
                <v-text-field
                    v-model="newAmount"
                    label="Amount"
                    prefix="$"
                    type="number"
                    :rules='requiredField'
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
                <v-select
                    v-model="newType"
                    label="Type"
                    :items="type"
                    :rules='requiredField'
                ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6">
                <v-select
                    v-model="newCategory"
                    label="Category"
                    :items="category"
                    :rules='requiredField'
                ></v-select>
            </v-col>
            <v-col cols="12" v-if="newCategory == 'Other'">
                <v-text-field
                    label="Other"
                    v-model="newOther"
                ></v-text-field>
            </v-col>
            <v-col cols="12">
                <v-text-field
                    label="Payee"
                    v-model="newPayee"
                    :rules='requiredField'
                ></v-text-field>
            </v-col>
            <!-- <v-col cols="12" sm="12" md="6">
                <v-text-field
                v-model="newBalance"
                label="Balance"
                readonly
                ></v-text-field>
            </v-col> -->
            <v-col cols="12" sm="12">
                <v-textarea
                    v-model="newDescription"
                    label="Description"
                    outlined
                    :rules='requiredField'
                ></v-textarea>
            </v-col>
            <v-col cols="12" sm="12" md="6">
                <v-file-input   
                    v-model="newReceipt"                             
                    class="pa-2"
                    label="Receipt"
                    filled
                    dense
                    multiple
                    prepend-icon="mdi-camera"
                    accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    @change="fileSelected"
                    show-size
                    :rules='requiredField'
                >
                    <template #selection="{ text, index }">
                        <v-chip small label close color="primary" @click:close="deleteChip(index)">{{ text }}</v-chip>
                    </template>
                </v-file-input>
                <!--
                <v-file-input
                chips
                show-size                        
                class="pa-2"
                label="Receipt"
                :placeholder="newReceipt"
                filled
                accept=".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                @change="fileSelected"
                ></v-file-input>
                -->
                <!-- <v-img
                max-height="280"
                max-width="350"
                :src="AWSLink"  
                ></v-img> -->
            </v-col>
            <!-- <v-col cols="12"
                v-for="doc in newReceipt"
                :key="doc.id"
            >
                <div v-if="doc.ext !='pdf' ">
                    <v-img
                        max-height="480"
                        max-width="550"
                        :src="doc.aws"
                    ></v-img>
                </div>
                <div v-if="doc.ext =='pdf' ">
                    <load-pdf 
                        :pdfFile="doc.aws"
                        :pdfName="doc.name"
                    />
                </div>
            </v-col> -->
            <v-col cols="12" sm="12">
                <v-checkbox
                    @click="addSignature()"
                    v-model="checkSignature"
                    label=" Staff Signature"
                    :rules='requiredField'
                ></v-checkbox>
                <v-expand-transition>
                    <v-text-field v-if="checkSignature" v-model="newSignature" readonly></v-text-field>
                </v-expand-transition>
            </v-col>
            <v-col cols="12">
                <v-select
                    v-model="status"
                    label="Payment status"
                    :items="statuses"
                    :rules='requiredField'
                ></v-select>
            </v-col>
            <v-col cols="12">
                <v-textarea
                    label="Payment notes"
                    v-model="newNote"
                ></v-textarea>
            </v-col>
            <v-col cols="12" sm="12" v-if="status == 'Paid'">
                <v-checkbox
                    @click="addManagerSignature()"
                    v-model="checkManagerSignature"
                    label=" Manager Signature"
                ></v-checkbox>
                <v-expand-transition>
                    <v-text-field v-if="checkManagerSignature" v-model="newManagerSignature" readonly></v-text-field>
                </v-expand-transition>
            </v-col>
            <v-col class="py-0" cols="12">
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="green darken-2"
                        icon
                        dark
                        @click="saveEditedPayrollReport(tabItems)"
                        :loading="isSavingEditLoading"
                        :disabled="isSavingEditLoading"
                    >
                        <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import axios from 'axios';
import {mapState, mapMutations} from "vuex";
import renameFileHelper from '../../../../mixins/renameFileHelper';

const url = require("../../../../client_config/config").url;

export default {
    mixins: [renameFileHelper],

    props: {
        tabItems: Object,
    },

    data () {
        return {
            staff: localStorage.getItem('Name'),
            type: ["Cash", "Debit Card"],
            category: [
                "Client Purchase",
                "Mileage",
                "Reimbursement",
                "Other"
            ],
            statuses: [
                'New',
                'Pending',
                'Paid',
                'Not paid',
                'Outstanding'
            ],

            dateMenu: false,
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            newDate: "",
            newAmount: "",
            newType: "",
            newCategory: "",
            newOther: "",
            newPayee: "",
            newDescription: "",
            newReceipt: null,
            newSignature: "",
            newManagerSignature: "",
            checkSignature: false,
            checkManagerSignature: false,
            status: "Outstanding",
            newNote: '',

            reimbursementID: "",
            uploadFile: "",
            signed: false,
            managerSigned: false,

            requiredField: [
                v => !!v || 'This field is required',
            ],

            isSavingEditLoading: false,
        }
    },

    computed: {
        ...mapState({
            selectedUserPayrollReport: state => state.payrollReportsHistories.selectedUserPayrollReport,
        }),

        staffName() {
            // `this` points to the component instance
            return this.$store.state.staff.staff.Name;
        },
    },

    methods: {
        ...mapMutations ({
            setSelectedCompPanel: "payrollReportsHistories/setSelectedCompPanel",
        }),
        
        async fileSelected(e) {
            this.uploadFile = await this.renameFileHelper(e, this.staffName, this.newPayee, this.newDate);
        },

        saveFile() {
            // Multiple file upload
            for (let i = 0; i < this.uploadFile.length; i++) {
                this.uploadFiles(this.uploadFile[i]);
            }
        },

        uploadFiles(file) {
            const formData = new FormData();
            formData.append('reimbursement', file);
            var ct = { headers:{ "content-type" : "multipart/form-data" } };

            axios.post(`${url}/reimbursements/fileuploader/${this.reimbursementID}/${this.selectedUserPayrollReport._id}`, formData, ct).then(res => {
                if(res.data.success){
                    console.log("Receipt uploaded successfully.");
                    // console.log("File location: " + res.data.file);
                } else {
                    console.log("Failed to upload.");
                }
            })
            .catch(err => {
                console.log(err);
            });
        },

        addSignature () {
            if (this.checkSignature == false) {
                this.newSignature = "";
                this.signed = false;
            }

            if (this.signed === false) {
                // this.newSignature = this.staff + " - " + new Date();
                if (this.signed == false) this.timeSigned();
                this.signed = true;
            }
        },

        addManagerSignature () {
            if (this.checkManagerSignature === false) {
                this.newManagerSignature = "";
                this.managerSigned = false;
            }
            if(this.managerSigned === false){
                // this.newManagerSignature = this.staff + " - " + new Date();
                if (this.managerSigned == false) this.timeSigned();
                this.managerSigned = true;
            }
        },

        timeSigned() {
            setTimeout(() => {
                const today = new Date();
                let year = today.getFullYear();
                let month = today.getMonth();
                let date = today.getDate();

                let h = today.getHours();
                let m = today.getMinutes();
                let s = today.getSeconds();

                if (this.checkSignature) this.newSignature = this.staff + " - " + new Date(year, month, date, h, m, s);
                if (this.checkManagerSignature) this.newManagerSignature = this.staff + " - " + new Date(year, month, date, h, m, s);
                
                if (this.signed || this.managerSigned) this.timeSigned();
            }, 1000);
        },

        saveEditedPayrollReport (tabItems) {
            this.isSavingEditLoading = true;

            if (this.$refs.form.validate()) {
                try {
                    const d = new Date(Date.now());
                    const newDate = new Date(this.newDate);

                    newDate.setHours(d.getHours())
                    newDate.setMinutes(d.getMinutes())
                    newDate.setSeconds(d.getSeconds())
                    newDate.setMilliseconds(d.getMilliseconds())
                    
                    var req_body = {
                        Date: newDate.toISOString(),
                        Amount: this.newAmount,
                        Type: this.newType,
                        Category: this.newCategory,
                        Other: this.newOther,
                        Payee: this.newPayee,
                        // Balance: this.newBalance,
                        Description: this.newDescription,
                        // Receipt: this.newReceipt,
                        EnteredBy: this.newSignature,
                        Manager: this.newManagerSignature,
                        Status: this.status,
                        EmployeeID: this.selectedUserPayrollReport._id,
                        Note: this.newNote
                    }

                    axios.post(`${url}/reimbursements`, req_body ).then(res => {
                        if (res.status == 200) {
                            tabItems.itemValue = parseFloat(req_body.Amount);
                            tabItems.isEdit = false;

                            this.newDate = "";
                            this.newAmount = "";
                            this.newType = "";
                            this.newCategory = "";
                            this.newOther = "";
                            this.newPayee = "";
                            this.newDescription = "";
                            this.newReceipt = null;
                            this.newSignature = "";
                            this.newManagerSignature = "";
                            this.status = "";
                            this.newNote = "";
                            this.signed = false;
                            this.managerSigned = false;

                            let snackbarMsg = {
                                saveEditedPayrollReport_snackbarText: "New reimbursement has been added successfully.",
                                saveEditedPayrollReport_snackbarColor: "success",
                                saveEditedPayrollReport_snackbar: true,
                            }

                            this.$emit("snackbarMsg", snackbarMsg);

                            this.setSelectedCompPanel(null);

                            this.reimbursementID = res.data._id;
                            this.saveFile();
                        }
                    }).catch(error => {
                        let snackbarText = error.response.data.msg;

                        let snackbarMsg = {
                            saveEditedPayrollReport_snackbarText: snackbarText,
                            saveEditedPayrollReport_snackbarColor: "error",
                            saveEditedPayrollReport_snackbar: true,
                        }

                        this.$emit("snackbarMsg", snackbarMsg);
                    });
                } catch (error) {
                    this.errorMsg("adding", "record", error);
                    
                } finally {
                    this.isSavingEditLoading = false;
                }
            } else {
                let snackbarMsg = {
                    saveEditedPayrollReport_snackbarText: "Please fill out all required fields.",
                    saveEditedPayrollReport_snackbarColor: "error",
                    saveEditedPayrollReport_snackbar: true,
                }

                this.$emit("snackbarMsg", snackbarMsg)
                this.isSavingEditLoading = false;
            }
        },

        errorMsg(action, item, error) {
            console.error(`An error occured whiling ${action} ${item}`, error);
        },
    }
}
</script>